import styled from "styled-components";

export const RowBadgeButton = styled.div`
 display:flex;
 gap: 8px;
 padding-bottom: 8px;
`;
